export default {
  // 获取字典表中的产品枚举
  DATA_DICT: '/maindata/dictData/listDataDictByDataType',
  // 新增服务
  ADD_SERVICE: '/maindata/service/save',
  // 查询服务列表
  SERVICE_LIST: '/maindata/service/listByPage',
  // 服务详情
  SERVICE_DETAIL: '/maindata/service/detailById',
  // 检查是否有重复名称
  CHECK_NAME: '/maindata/service/checkNameRepeat',
  // 审批通过或驳回
  APPROVAL: '/maindata/service/approve',
  // 获取当前费目列表
  CURR_EXPENSE: '/maindata/service/expenseListByServices',
};
